module.exports = __webpack_public_path__ + "assets/success-check.c63fc684.svg";